class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


/* MG 2026-08-19 v2: drawer sync helper.
   - Scoped refresh: replaces ONLY the item list (cart-drawer-items) + native .totals,
     leaving the drawer footer intact so Discount Ninja's injected summary survives.
   - Watches third-party (ICU) cart adds (no `sections` param) and refreshes scoped.
   - window.__mgDrawerRefresh(openAfter) is reused by the upload-product flow. */
(function () {
  if (window.__mgCartSyncPatched) return;
  window.__mgCartSyncPatched = true;
  var pending = null;

  function swapScoped(sections) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !sections['cart-drawer']) return false;
    var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    var fresh = doc.querySelector('#CartDrawer');
    var target = document.getElementById('CartDrawer');
    if (!fresh || !target) return false;
    var freshItems = fresh.querySelector('cart-drawer-items');
    var curItems = target.querySelector('cart-drawer-items');
    /* MT-067: an empty drawer keeps its "Your cart is empty" layout (class on <cart-drawer>) after a scoped
       swap, so the first item added by the upload path showed as an empty cart. Empty <-> filled: full swap. */
    var freshDrawer = doc.querySelector('cart-drawer');
    var freshEmpty = freshDrawer ? freshDrawer.classList.contains('is-empty') : !!(freshItems && freshItems.classList.contains('is-empty'));
    if (drawer.classList.contains('is-empty') !== freshEmpty) {
      drawer.classList.toggle('is-empty', freshEmpty);
      curItems = null;
    }
    if (freshItems && curItems) {
      curItems.innerHTML = freshItems.innerHTML;
      if (freshItems.classList.contains('is-empty')) curItems.classList.add('is-empty');
      else curItems.classList.remove('is-empty');
      var ft = fresh.querySelector('.totals');
      var ct = target.querySelector('.totals');
      if (ft && ct) ct.innerHTML = ft.innerHTML;
    } else {
      /* structure mismatch (empty -> filled or vice versa): full swap fallback */
      target.innerHTML = fresh.innerHTML;
      var inner = drawer.querySelector('.drawer__inner');
      if (inner && !freshEmpty) inner.classList.remove('is-empty');
      var ov = drawer.querySelector('#CartDrawer-Overlay');
      if (ov) ov.addEventListener('click', drawer.close.bind(drawer));
    }
    if (sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) {
        var bdoc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var bs = bdoc.querySelector('.shopify-section');
        if (bs) bubble.innerHTML = bs.innerHTML;
      }
    }
    return true;
  }

  function refresh(openAfter) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var ok = swapScoped(sections);
        if (ok && openAfter) {
          var drawer = document.querySelector('cart-drawer');
          if (drawer && !drawer.classList.contains('active')) drawer.open();
        }
        return ok;
      });
  }
  window.__mgDrawerRefresh = refresh;

  function schedule() {
    if (pending) return;
    pending = setTimeout(function () {
      pending = null;
      refresh(false).catch(function () {});
    }, 350);
  }

  function isCartAdd(url) {
    try { return /\/cart\/add(\.js|\.json)?([?#]|$)/.test(String(url)); } catch (e) { return false; }
  }
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = (typeof input === 'string') ? input : (input && input.url);
    var result = origFetch.apply(this, arguments);
    if (isCartAdd(url)) {
      var themeAdd = false;
      try {
        var body = init && init.body;
        if (body && typeof body.get === 'function') themeAdd = !!body.get('sections');
        else if (typeof body === 'string') themeAdd = body.indexOf('sections') !== -1;
      } catch (e) {}
      if (!themeAdd) result.then(function (r) { if (r && r.ok) schedule(); }).catch(function () {});
    }
    return result;
  };
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__mgCartAdd = String(method).toUpperCase() === 'POST' && isCartAdd(url);
    return origOpen.apply(this, arguments);
  };
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this.__mgCartAdd) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) schedule();
      });
    }
    return origSend.apply(this, arguments);
  };
})();
